import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BLOGS as FALLBACK_BLOGS } from '../mock';

const BlogStrip = ({ category, title = 'From the Journal', linkable = false, showTitle = true }) => {
  const blogs = FALLBACK_BLOGS;

  const posts = (category ? blogs.filter(b => b.category === category) : blogs).slice(0, 3);
  if (!posts.length) return null;

  return (
    <section className={`bg-[#FFFFFF] ${showTitle ? 'py-10 lg:py-12' : 'pt-12 pb-12 lg:pt-16 lg:pb-16 border-t border-[#e5ddce]'}`}>
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
        {showTitle && (
          <div className="flex items-end justify-between mb-6">
            <h2 className="font-serif text-2xl lg:text-3xl text-[#1a1a1a]">{title}</h2>
            {linkable && (
              <Link to="/blogs" className="text-[11px] tracking-widest-2 uppercase text-[#999959] hover-underline hidden sm:inline-block">View All</Link>
            )}
          </div>
        )}
        <div className="flex sm:grid sm:grid-cols-3 overflow-x-auto sm:overflow-visible snap-x snap-mandatory sm:snap-none no-scrollbar gap-4 lg:gap-6 -mx-6 px-6 sm:mx-0 sm:px-0">
          {posts.map((b) =>
            linkable ? (
              <Link key={b.slug} to={`/blogs/${b.slug}`} className="group block flex-shrink-0 snap-center w-full sm:w-auto">
                <div className="aspect-[4/3] overflow-hidden bg-[#f7f4ee]">
                  <img src={b.image} alt={b.title} className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105" />
                </div>
                <div className="font-serif text-base text-[#1a1a1a] leading-snug mt-3">{b.title}</div>
              </Link>
            ) : (
              <div key={b.slug} className="flex-shrink-0 snap-center w-full sm:w-auto">
                <div className="aspect-[4/3] overflow-hidden bg-[#f7f4ee]">
                  <img src={b.image} alt={b.title} className="w-full h-full object-cover" />
                </div>
                <div className="font-serif text-base text-[#1a1a1a] leading-snug mt-3">{b.title}</div>
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default BlogStrip;

